import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Grid } from '@material-ui/core';
import { StyledHeader } from './styles';
import Logo from '../logo';
import { Button } from '../Buttons';
import { useTranslation } from 'react-i18next';
import Link from '../Link';
import { SIGN_IN } from '../../utils';

const Header = props => {
	const [transparent, setTransparent] = useState(true);
	const { t, i18n } = useTranslation();
	const language = i18n.language;

	const handleOnclick = () => {
		const newLang = language === 'en' ? 'es' : 'en';
		i18n.changeLanguage(newLang);
	};

	const handleChecked = language === 'es' ? true : false;

	useEffect(() => {
		setTransparent(true);
	}, []);

	const handleScroll = () => {
		if (window.scrollY > 2) {
			setTransparent(false);
		} else {
			setTransparent(true);
		}
	};

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	return (
		<StyledHeader transparent={transparent}>
			<AppBar position="static">
				<Toolbar disableGutters={true}>
					<Grid
						container
						justify="space-between"
						direction="row"
						alignItems="center"
					>
						<Grid item md={2}>
							<Logo />
						</Grid>
						<Grid item md={10}>
							<Grid container justify="flex-end">
								{props.children}
								<Link href={SIGN_IN}>
									<Button
										content={t('general.actions.signIn')}
										variant={'outlined'}
										textColor={'primary'}
										className="signin-button"
									/>
								</Link>

								<label class="switch">
									<input
										type="checkbox"
										checked={handleChecked}
										onChange={handleOnclick}
									/>
									<span class="slider round"></span>
									<span class={`text en ${language !== 'en' && 'lng-color'}`}>
										EN
									</span>
									<span class={`text es ${language !== 'es' && 'lng-color'}`}>
										ES
									</span>
								</label>
							</Grid>
						</Grid>
					</Grid>
				</Toolbar>
			</AppBar>
		</StyledHeader>
	);
};

export default Header;
